export const noPartnerToDelete = 'No contact selected';
export const errorUpdatingOption = 'Error updating option!';
export const twilightLabel = 'Twilight booking option';
export const twilightText = 'To show the twilight option during booking find it in this region\'s options and change the type to "Twilight".';
export const virtualTwilightLabel = 'Virtual twilight booking option';
export const virtualTwilightText = 'To show the twilight option during booking find it in this region\'s options and change the type to "Virtual Twilight".';
export const errorUpdatingPackages = 'Error updating packages!';
export const deletePartnerLabel = 'Delete this partner?';
export const deletePartnerButton = 'yes, delete';
export const regionNameHelp = 'The name of this region.';
export const regionNameLabel = 'Name';
export const regionNamePlaceholder = 'Front Range';
export const regionFlexBookingHelp = 'Amount of time in milliseconds to delay releasing service into flex booking status.';
export const regionFlexBookingLabel = 'How long before removing a preferred technician and offering to all technicians.';
export const regionTimezoneHelp = 'The timezone of this region.';
export const regionTimezoneLabel = 'Timezone';
export const regionTimezonePlaceholder = 'MTN';
export const regionLatitudeHelp = 'The latitude of the center of this region (approximate)';
export const regionLatitudeLabel = 'Latitude';
export const regionLatitudePlaceholder = '39.739235';
export const regionLongitudeHelp = 'The longitude of the center of this region (approximate).';
export const regionLongitudeLabel = 'Longitude';
export const regionLongitudePlaceholder = '-104.99025';
export const regionStateHelp = 'The two letter state code for this region.';
export const regionStateLabel = 'State';
export const regionStatePlaceholder = 'CO';
export const regionInfoPathHelp = 'Info Path';
export const regionInfoPathPlaceholder = 'www.pineapplelabs.io/region/???';
export const addNewPartnerButton = 'add new partner';
export const addNewPartnerLabel = 'Add a new partner';
export const addNewPackageButton = 'new package';
export const successAddedPartner = 'Successfully created package.';
